// @ts-nocheck
/**
 * Rating glyph Unicode pairs — shared by host adapter, web HTML adapter, and
 * editor preview so filled/empty characters cannot drift across surfaces.
 *
 * Omit / unknown glyph id → stars (backward compatible with existing templates).
 */

import type { RatingGlyphId } from '../../types/component';

export type { RatingGlyphId };

export const RATING_GLYPH_IDS: readonly RatingGlyphId[] = [
  'stars',
  'dots',
  'bars',
  'hearts',
] as const;

export const RATING_GLYPHS: Record<
  RatingGlyphId,
  { readonly filled: string; readonly empty: string }
> = {
  stars: { filled: '★', empty: '☆' },
  dots: { filled: '●', empty: '○' },
  bars: { filled: '■', empty: '□' },
  hearts: { filled: '♥', empty: '♡' },
};

export const DEFAULT_RATING_GLYPH: RatingGlyphId = 'stars';

export function resolveRatingGlyphId(raw: unknown): RatingGlyphId {
  if (typeof raw === 'string' && raw in RATING_GLYPHS) {
    return raw as RatingGlyphId;
  }
  return DEFAULT_RATING_GLYPH;
}

export function ratingGlyphPair(raw: unknown): {
  filled: string;
  empty: string;
} {
  return RATING_GLYPHS[resolveRatingGlyphId(raw)];
}
